import { createApp } from '@app/adapters/create-app'
import CompanyLinksOverview from '@app/application/company_links/components/company-links-overview.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const element = doc.querySelector(
      "[data-behaviour='company-links-overview']"
    ) as HTMLElement

    if (element) {
      const { modalMode } = element.dataset ?? {}

      createApp(CompanyLinksOverview, {
        modalMode: modalMode === 'true',
      }).mount(element)
    }
  })
}
